import { randomIndex } from '@/mixins/random';

function buildSpawnList(vacantTiles, spawnList, random = true) {
	spawnList.map((spawner) => {
		let newSpawner = spawner;
		const index = random ? randomIndex(vacantTiles) : 0;

		if (vacantTiles.length) {
			newSpawner = Object.assign(spawner, {
				tile: vacantTiles.splice(index, 1)[0],
			});
		}

		return newSpawner;
	});

	return spawnList.filter(spawner => spawner.tile);
}

export default {
	state: {
		// cycleCountdown: false,
		spawnCompletionAction: false, //
		remainingSpawns: 0,
	},
	actions: {
		createSpawner(context, payload) {
			let randomSpawnOrder = true;
			const vacantTiles = context.rootGetters.vacantTiles;

			if (payload.spawnList.length > vacantTiles.length
				&& context.rootGetters.currentStageSettings.final_stage) {
				context.commit("endGame");
				randomSpawnOrder = false;
			}

			const spawnList = buildSpawnList(vacantTiles, payload.spawnList, randomSpawnOrder);

			context.commit("setRemainingSpawns", { count: spawnList.length });
			context.dispatch("activateSpawner", {
				acceleratorList: spawnList,
				action: "spawn",
			});
		},
		activateSpawner(context, payload) {
			context.commit("activateCycleCountdown");
			context.dispatch("startAccelerator", payload);
		},
		spawn(context, payload) {
			payload.tile.insertCat(payload.breed, payload.state);
		},

		spawnCompletionAction(context) { //
			if (context.state.spawnCompletionAction) {
				context.dispatch(context.state.spawnCompletionAction);
			}
		},
	},
	mutations: {
		setRemainingSpawns(state, payload) {
			state.remainingSpawns = payload.count;
		},
		decrementRemainingSpawns(state) {
			state.remainingSpawns -= 1;
		},
		// activateCycleCountdown(state) {
		// 	state.cycleCountdown = true;
		// },
		// deactivateCycleCountdown(state) {
		// 	state.cycleCountdown = false;
		// },
		setSpawnCompletionAction(state, payload) { //
			state.spawnCompletionAction = payload.action;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/spawner.js